import { mapGetters, mapActions } from 'vuex'
import _get from 'lodash/get'

export default {
  data() {
    return {
      schedulerModalOpen: false,
    }
  },
  methods: {
    ...mapActions('healthActions', ['schedulerModalClicked']),
    closeSchedulerModal() {
      this.schedulerModalOpen = false
    },
    openSchedulerModal() {
      this.schedulerModalClicked({})
        .then((this.schedulerModalOpen = true))
        .catch(console.error)
    },
  },
  computed: {
    ...mapGetters('member', ['memberInfo']),
    hasSchedulerConfig() {
      return !!_get(this.healthAction, 'scheduler')
    },
    healthActionSchedulerConfig() {
      return _get(this.healthAction, 'scheduler')
    },
    schedulerCardButtonMessage() {
      return _get(this.healthActionSchedulerConfig, 'cardButtonMsg')
    },
    schedulerCardDescription() {
      return _get(this.healthActionSchedulerConfig, 'cardDesc')
    },
    schedulerLearnMoreDescription() {
      return _get(this.healthActionSchedulerConfig, 'learnMoreDesc')
    },
    schedulerLearnMoreUrl() {
      return _get(this.healthActionSchedulerConfig, 'learnMoreUrl')
    },
    schedulerLogo() {
      return `${window.HM_CONFIG.S3_ROOT}/${_get(
        this.healthActionSchedulerConfig,
        'logoFilename'
      )}`
    },
    schedulerLogoAltText() {
      return _get(this.healthActionSchedulerConfig, 'logoAltText')
    },
    schedulerModalHeader() {
      return _get(this.healthActionSchedulerConfig, 'modalHeader')
    },
    schedulerPhoneNumber() {
      return _get(this.healthActionSchedulerConfig, 'phoneNumber')
    },
    schedulerPhoneNumberMessage() {
      return _get(this.healthActionSchedulerConfig, 'phoneNumberMsg')
    },
    schedulerUrl() {
      return _get(this.healthActionSchedulerConfig, 'schedulerUrl')
    },
    schedulerUrlRedirectMessage() {
      return _get(this.healthActionSchedulerConfig, 'schedulerUrlMsg')
    },
  },
}
